import { ICupom } from "../interface/ICupom";
import { IProdutoPedido } from "../interface/IProdutoPedido";

/**
 * Verifica se um cupom está associado a um produto específico
 * Baseado no padrão usado em useResgateFidelidade onde o código do cupom contém o UUID do produto
 */
export const verificarCupomAssociadoProduto = (
    cupom: ICupom,
    produtoUuid: string
): boolean => {
    if (!cupom.codigo || !produtoUuid) {
        return false;
    }

    // Verifica se o código do cupom contém o UUID do produto
    return cupom.codigo.includes(produtoUuid);
};

/**
 * Filtra cupons que estão associados a produtos que foram removidos
 */
export const filtrarCuponsProdutosRemovidos = (
    cupons: ICupom[],
    produtosRemovidos: IProdutoPedido[]
): ICupom[] => {
    if (!cupons || cupons.length === 0 || !produtosRemovidos || produtosRemovidos.length === 0) {
        return [];
    }

    const uuidsProdutosRemovidos = produtosRemovidos.map(p => p.uuid);
    
    return cupons.filter(cupom => {
        // Verifica se o cupom está associado a algum produto removido
        return uuidsProdutosRemovidos.some(uuid => 
            verificarCupomAssociadoProduto(cupom, uuid)
        );
    });
};

